import React, {useState} from "react";
import {Box, Shimmer} from "@unibuddy/patron";
import get from "lodash/get";
import ContentPreview from "../ContentPreview/ContentPreview";
import MentorPreviewCard from "../MentorPreview/MentorPreviewCard";
import {useParseMessages} from "./useParseMessages";

import s from "../../../../../shared/Chat/components/MessageText/MessageText.pcss";

const UnfurlContentWrapper = ({children}: {children: React.ReactChild}) => {
    return (
        <Box padding="xsmall" display="flex" justifyContent="center">
            {children}
        </Box>
    );
};

const UnfurlLink = ({
    text,
    isDegreeTypesEnabled,
    isBlogsEnabled,
    isShowCountryFlagEnabled,
    rootURL = "",
    ambassadorId = "",
}) => {
    const [loadingCard, setLoadingCard] = useState(false);
    const messages = useParseMessages({
        text,
        isDegreeTypesEnabled,
        isBlogsEnabled,
        setLoadingCard,
    });
    const card: string = s.card;

    return (
        <>
            {loadingCard ? (
                <UnfurlContentWrapper>
                    <Box className={card} width={340} borderRadius={"xxsmall"} bgColor={"white"}>
                        <Shimmer height={340} width={340}>
                            <rect x="0" y="0" rx="4" ry="4" width="340" height="280" />
                            <rect x="0" y="290" rx="4" ry="4" width="340" height="40" />
                        </Shimmer>
                    </Box>
                </UnfurlContentWrapper>
            ) : (
                messages?.map((el) => {
                    const post = get(el, "post");
                    const profile = get(el, "publicMentor");
                    if (post) {
                        const postId: string = get(post, "id");
                        const blogDetailLink = `${rootURL}/blog/post/${postId}`;
                        return (
                            <UnfurlContentWrapper>
                                <Box className={card}>
                                    <ContentPreview
                                        key={postId}
                                        post={post}
                                        blogDetailLink={blogDetailLink}
                                        ambassadorId={ambassadorId}
                                    />
                                </Box>
                            </UnfurlContentWrapper>
                        );
                    }
                    if (profile) {
                        const profileId: string = get(profile, "id", "");
                        const amboChatLink = `${rootURL}/inbox/chatwith/${profileId}`;
                        return (
                            <UnfurlContentWrapper>
                                <Box className={card}>
                                    <MentorPreviewCard
                                        {...profile}
                                        key={profileId}
                                        showChatButton
                                        isShowCountryFlagEnabled={isShowCountryFlagEnabled}
                                        isDegreeTypesEnabled={isDegreeTypesEnabled}
                                        amboChatLink={amboChatLink}
                                        ambassadorId={ambassadorId}
                                    />
                                </Box>
                            </UnfurlContentWrapper>
                        );
                    }
                    return null;
                })
            )}
        </>
    );
};

export default UnfurlLink;
